import { api } from "../../utils/api";

export async function generateShipping(data) {
  try {
    const response = await api.post(`homologation/requesting-shipping`, data);
    return response.data;
  } catch (error) {
    console.error("Erro na requisição generateShipping:", error);

    const backendErrors = error.response?.data?.errors;

    // Extrai todas as mensagens do objeto errors
    const errorMessage = backendErrors
      ? Object.values(backendErrors).flat().join("\n") // separa por linha
      : error.response?.data?.message || "Erro inesperado.";

    throw new Error(errorMessage);
  }
}
